import type { ConnectionsColumnsState, ConnectionsTableColumnsKeys } from "../model/types";

export const transformConnectionsColumnsStateToArray = ({
  state,
}: {
  state: ConnectionsColumnsState;
}): ConnectionsTableColumnsKeys[] => {
  return Object.entries(state).flatMap(([key, value]) => {
    if (value) {
      return key as ConnectionsTableColumnsKeys;
    }
    return [];
  });
};
